var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wi100 hi100",attrs:{"id":"newsList"}},[_c('dv-scroll-board',{staticStyle:{"padding":"0px"},attrs:{"config":_vm.dataConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }